import React from 'react';
import track from "../assets/images/track.svg";
import customize from "../assets/images/customize.svg";
import monitor from "../assets/images/monitor.svg";
import banner from "../assets/images/banner.svg";

const FeatureCard = () => {
  return (
    <div className="container-fluid py-5" >
      <div className="row justify-content-center">
        <div className="col-lg-10 col-xl-8" data-aos="zoom-in">
          <div className="card feature-card">
            <div className="row align-items-center h-100">
              {/* Left Content */}
              <div className="col-lg-7 col-md-12 col-sm-12 col-12">
                <div className="card-wrapper">
                  {/* Icon */}
                  

                  {/* Title */}
                  <h1 className="card-title mb-2">
                    Decode <span className="highlight-text">Code Quality</span>
                  </h1>

                  {/* Description */}
                  <p className="card-description mb-4">
                    Identify and comprehend code quality smells early. DCode helps you identify code smells and quality concerns across Java, C#, and Python projects.
                  </p>

                  {/* Feature List */}
                  <ul className="card-list">
                    <li className="card-item">
                      <div className="bullet-point"></div>
                      Detect code smells at architecture, design, implementation, and test level
                    </li>
                    <li className="card-item">
                      <div className="bullet-point"></div>
                      Track key code quality metrics
                    </li>
                    <li className="card-item">
                      <div className="bullet-point"></div>
                      Identify hotspots and areas of technical debt
                    </li>
                  </ul>

                  {/* CTA Button */}
                 
                </div>
              </div>

              {/* Right Visual */}
              <div className="col-lg-5 col-md-12 col-sm-12 col-12 visual-container">
                
                  <div className="dashboard-mockup">
                    <img src={banner} className='track-svg' />
               
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-lg-10 col-xl-8" data-aos="zoom-in">
          <div className="card feature-card">
            <div className="row align-items-center h-100">

                {/* Right Visual */}
              <div className="col-lg-5 col-md-12 col-sm-12 col-12 visual-container">
               
                  <div className="dashboard-mockup">
                    <img src={track} className='track-svg' />
                  </div>
            
              </div>
              {/* Left Content */}
              <div className="col-lg-7 col-md-12 col-sm-12 col-12">
                <div className="card-wrapper">
                  {/* Icon */}
                  

                  {/* Title */}
                  <h1 className="card-title mb-2">
                    Track <span className="highlight-text">Code Quality</span> Automatically
                  </h1>

                  {/* Description */}
                  <p className="card-description mb-4">
                    Connect your repository to DCode and let automated analysis monitor your code as it evolves—continuously tracking quality without disrupting your workflow.
                  </p>

                  {/* Feature List */}
                  <ul className="card-list">
                    <li className="card-item">
                      <div className="bullet-point"></div>
                      Seamless integration with CI pipelines
                    </li>
                    <li className="card-item">
                      <div className="bullet-point"></div>
                      Track how code quality evolves over time
                    </li>
                    <li className="card-item">
                      <div className="bullet-point"></div>
                      Detect emerging technical debt early
                    </li>
                  </ul>

                  {/* CTA Button */}
                 
                </div>
              </div>

              
            </div>
          </div>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-lg-10 col-xl-8" data-aos="zoom-in">
          <div className="card feature-card">
            <div className="row align-items-center h-100">
              {/* Left Content */}
              <div className="col-lg-7 col-md-12 col-sm-12 col-12">
                <div className="card-wrapper">
                  {/* Icon */}
                  

                  {/* Title */}
                  <h1 className="card-title mb-2">
                    Customize Your <span className="highlight-text">Analysis</span>
                  </h1>

                  {/* Description */}
                  <p className="card-description mb-4">
                    Code analysis tools detect issues based on heuristics but they don't know your code as you do. With DCode, you can fine-tune your analysis by enabling or disabling specific code smells and marking individual instances as false positives. Focus only on what truly matters to your team.
                  </p>

                  {/* Feature List */}
                  <ul className="card-list ">
                    <li className="card-item">
                      <div className="bullet-point"></div>
                      Configure rules for code quality checks
                    </li>
                    <li className="card-item">
                      <div className="bullet-point"></div>
                      Exclude specific smell instances you’ve reviewed and dismissed
                    </li>
                    
                  </ul>

                  {/* CTA Button */}
                 
                </div>
              </div>

              {/* Right Visual */}
              <div className="col-lg-5 col-md-12 col-sm-12 col-12 visual-container">
                
                  <div className="dashboard-mockup">
                    <img src={customize} className='track-svg' />
                  </div>
            
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-lg-10 col-xl-8" data-aos="zoom-in">
          <div className="card feature-card">
            <div className="row align-items-center h-100">

                {/* Right Visual */}
              <div className="col-lg-5 col-md-12 col-sm-12 col-12 visual-container">
                
                  <div className="dashboard-mockup">
                    <img src={monitor} className='track-svg' />
                  </div>
               
              </div>
              {/* Left Content */}
              <div className="col-lg-7 col-md-12 col-sm-12 col-12">
                <div className="card-wrapper">
                  {/* Icon */}
                  

                  {/* Title */}
                  <h1 className="card-title mb-2">
                    Monitor <span className="highlight-text">Project Health </span>
                  </h1>

                  {/* Description */}
                  <p className="card-description mb-4">
                    From bottlenecks in PRs to productivity drops—get the metrics that matter most.
                  </p>

                  {/* Feature List */}
                  <ul className="card-list">
                    <li className="card-item">
                      <div className="bullet-point"></div>
                      Track team velocity and collaboration
                    </li>
                    <li className="card-item">
                      <div className="bullet-point"></div>
                      Analyze PR review times and cycle durations
                    </li>
                    <li className="card-item">
                      <div className="bullet-point"></div>
                      Spot risks before they become blockers
                    </li>
                  </ul>

                  {/* CTA Button */}
                 
                </div>
              </div>

              
            </div>
          </div>
        </div>
      </div>

      
    </div>
  );
};

export default FeatureCard;